
import { HttpClient } from "../../../adapters/xhr/httpClient";
import { emailRegex, emailRegex_evalue, getConfiguredLabel } from "../../../common/commonHelper";
import { adminPage, emailUniqueMsg } from "../../../common/labelConstants";
import { ApiURLs, API_BASE_URL } from "../../../common/url";
import { validateEmailExistsAlready } from "../../../store/listing/listingSlice";


const customValidators = {
    uniqueEmailValidator: "uniqueEmailValidator",
    confirmPassword: 'confirmPassword',
}

export function getCustomValidator(name) {
    switch (name) {
        case customValidators.uniqueEmailValidator:
            return uniqueEmailValidator
        case customValidators.confirmPassword:
            return confirmPassword
        default: break;
    }
}

async function uniqueEmailValidator(email, { token, id }, form) {
    const { register, getValues, setError } = form || {};
    const authType = typeof getValues == 'function' ? getValues('authType') : null
    let isValidEmailPattern = false;
    let msg = "Invalid email address."
    if (authType) {
        if (authType.val && authType.val.toLowerCase && authType.val.toLowerCase() === 'form') {
            if (email.match(emailRegex)) {
                isValidEmailPattern = true
            }
        }
        else {
            if (email.match(emailRegex_evalue)) {
                isValidEmailPattern = true
            }
            else {
                msg = "Invalid email address. eg. example@evalueserve.com"
            }
        }
    }

    if (!isValidEmailPattern) {
        return msg;
    }

    const response = await HttpClient.POST(API_BASE_URL + ApiURLs.Data.getEmail, {
        headers: { authorization: token },
        data: { emailId: email, id: id },

    })

    if (response) {

        let isPresent = response.data.isPresent
        if (isPresent) {
            return getConfiguredLabel(adminPage, emailUniqueMsg);
        }
        return;
    }
    return getConfiguredLabel(adminPage, emailUniqueMsg);;


    //  const isValid = email !== "Example@Evalueserve.Com";

};

function confirmPassword(val, { token, id, field, userInfo }, form,inputForm) {
    const { register, getValues, setError } = form;
    const password_val = getValues('password')
    const password_val_lower = password_val.toLowerCase();
    let email ;
    if(userInfo){
        email = userInfo.email || userInfo.emailId;
    }
    if(inputForm){
        email = inputForm.control._formValues.emailId
    }
    email = email.toLowerCase();
    let [username, domain] = email.split("@");
    username = username.toLowerCase()
    domain = domain.replace('.com','').toLowerCase()
    const isInvalid = email.includes(password_val_lower) || password_val_lower.includes(username) || password_val_lower.includes(domain);

    if (val === password_val) {
        if (!isInvalid) {
            setError(field, null);
            return;
        }
        else {
            setError(field, { type: 'custom', message: 'The password can not be derivative of email' });
            return 'The password can not be derivative of email'
        }
    }
    else {
        setError(field, { type: 'custom', message: 'The passwords do not match.' });
        return 'The passwords do not match.'
    }



    //  const isValid = email !== "Example@Evalueserve.Com";

};

